export default {
  data() {
    return {
      mixin_app: null,
      mixin_all_published_apps: [],
    };
  },

  computed: {
    _is_organization_admin() {
      return this.$rc.$state.isOrganizationAdmin();
    },
  },

  methods: {
    mixinMonthlyFeePretty(millicents) {
      if (millicents == null) return '';
      return millicents > 0 ? `${this.$rc.pretty(millicents, 'usd')}/mo` : 'Free';
    },

    mixinGetAllAvailableApps(cb) {
      this.$rc.rest({
        spinner: false,
        endpoint: 'LIST: /api/v1/apps/store',
        params: {
          organization_id: this.$rc.getOrganizationId(),
          full_text: this.full_text,
        },
        on_success: data => {
          this.mixin_all_published_apps = data.results;
          if (cb && typeof cb === 'function') {
            cb(data.results);
          }
        },
        on_error: 'Unable to search available apps',
      });
    },

    mixinGetAppById(app_id, fail_silently, cb) {
      this.$rc.rest({
        spinner: false,
        endpoint: `GET: /api/v1/apps/store/:app_id`,
        params: {
          app_id,
        },
        on_success: data => {
          this.mixin_app = data?.profile;
          if (cb && typeof cb === 'function') {
            cb(data);
          }
        },
        on_error: fail_silently ? null : 'Unable to fetch app information',
      });
    },

    mixinGetAppByEnumName(app_enum_name, fail_silently) {
      const app_id = this.$rc.resolveAppName(app_enum_name);
      this.mixinGetAppById(app_id, fail_silently);
    },

    mixinDoAppInstall(after_install, app_id, agreement_specimen) {
      if (!this._is_organization_admin) {
        this.$rc.alert('Permission Denied', 'You must be an organization admin to install apps.');
        return;
      }

      this.$rc.rest({
        spinner: true,
        endpoint: 'PUT: /api/v1/app/store/do-install',
        params: {
          app_id,
          organization_id: this.$rc.getOrganizationId(),
          agreement_specimen,
        },
        on_success: data => {
          const alert_markdown_params = [
            this.app.after_install_title,
            this.app.after_install_detail_md,
          ];
          if (after_install && typeof after_install === 'function') {
            alert_markdown_params.push(after_install);
          }
          this.$rc.alertMarkdown(...alert_markdown_params);
          this.$rc.updateInstalledApps();
        },
        on_error: 'Unable to install app',
      });
    },

    mixinOnClickUninstallApp(after_uninstall, app_label = 'App') {
      if (!this._is_organization_admin) {
        this.$rc.alert('Permission Denied', 'You must be an organization admin to uninstall apps.');
        return;
      }

      let body = `Uninstall ${app_label}?`;
      if (!this.is_free) {
        body += ` This will stop all billing for this app.`;
      }

      this.$rc.confirm({
        title: 'Confirm Uninstall App',
        body,
        btn_text_ok: 'Uninstall',
        btn_text_cancel: 'Cancel',
        on_ok: () => {
          this.mixinDoUninstallApp(after_uninstall);
        },
      });
    },

    mixinDoUninstallApp(after_uninstall, app_label = 'this app') {
      if (!this._is_organization_admin) {
        this.$rc.alert('Permission Denied', 'You must be an organization admin to uninstall apps.');
        return;
      }

      this.$rc.rest({
        spinner: true,
        endpoint: 'PUT: /api/v1/app/store/do-uninstall',
        params: this.app,
        on_success: data => {
          this.$rc.alert('App Uninstalled', `You have uninstalled ${app_label}`);
          if (after_uninstall && typeof after_uninstall === 'function') {
            after_uninstall(this.app.app_id);
          }
          this.$rc.updateInstalledApps();
        },
        on_error: 'Unable to uninstall app',
      });
    },

    mixinOnClickCancelAppTrial(after_uninstall, app_label = 'this app') {
      if (!this._is_organization_admin) {
        this.$rc.alert(
          'Permission Denied',
          'You must be an organization admin to cancel app trials.'
        );
        return;
      }

      this.$rc.confirm({
        title: 'Cancel Free Trial',
        body: `Cancel your free trial for ${app_label}? You will lose access to the app immediately and you will not be charged.`,
        btn_text_ok: 'Cancel Trial',
        btn_text_cancel: 'Keep Trial',
        on_ok: () => {
          this.mixinDoUninstallApp(after_uninstall, app_label);
        },
      });
    },
  },
};
